import { useIsOrgAdmin } from "@/crud/account/hooks";
import { useProgram } from "@/crud/pricing/hooks";
import { UpgradeButton } from "@/pages/Billing/UpgradeButton";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

interface UpgradeDialogProps {
  organizationId: number;
  title: string;
  alertText: React.ReactNode;
  open: boolean;
  onClose: () => void;
}

export const UpgradeDialog = ({
  organizationId,
  title,
  alertText,
  open,
  onClose,
}: UpgradeDialogProps): React.ReactElement => {
  const { data: program } = useProgram(organizationId);
  const isOrgAdmin = useIsOrgAdmin(organizationId);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{alertText}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="secondary">
          Close
        </Button>
        <UpgradeButton
          organizationId={organizationId}
          isAdmin={isOrgAdmin}
          activeProgram={program}
        />
      </DialogActions>
    </Dialog>
  );
};
